import { TQueryDocumentSnapshot } from "common/types/FirebaseTypes";

export class TakeOffFormatedItem {
  description: string;
  quantity: string;
  unit: string;
  isStage: boolean;
  index: number;
  parentIndex: number;
  listIndex: number;
  parentListIndex: number;
  descriptionArray: string[];
  quantityArray: string[];
  unitArray: string[];
  resultQuantity: number;
  modelMapId: string;
  GUID?: any;

  constructor(
    description: string,
    quantity: string,
    unit: string,
    isStage: boolean,
    index: number,
    parentIndex: number,
    listIndex: number,
    parentListIndex: number,
    descriptionArray: string[],
    quantityArray: string[],
    unitArray: string[],
    resultQuantity: number,
    modelMapId: string,
    GUID?: any
  ) {
    this.description = description;
    this.quantity = quantity;
    this.unit = unit;
    this.isStage = isStage;
    this.index = index;
    this.parentIndex = parentIndex;
    this.listIndex = listIndex;
    this.parentListIndex = parentListIndex;
    this.descriptionArray = descriptionArray;
    this.quantityArray = quantityArray;
    this.unitArray = unitArray;
    this.resultQuantity = resultQuantity;
    this.modelMapId = modelMapId;
    if (GUID) this.GUID = GUID;
  }
}

export function createTakeOffFormatedItemFromDocument(
  doc: TQueryDocumentSnapshot
) {
  let data: any = doc.data();
  if (!data) throw new Error("TakeOffFormat data is invalid!");

  return new TakeOffFormatedItem(
    data.description,
    data.quantity,
    data.unit,
    data.isStage,
    data.index,
    data.parentIndex,
    data.listIndex,
    data.parentListIndex,
    data.descriptionArray,
    data.quantityArray,
    data.unitArray,
    data.resultQuantity,
    data.modelMapId,
    data.GUID
  );
}



// WEBPACK FOOTER //
// ./src/modules/takeOff/models/TakeOffFormatedItem.ts